import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TF911 } from '@rsos/capstone/src/constants/capabilities';
import { selectUserPermissionsByApp } from '@rsos/sinatra';
import { TF911_PERMISSION } from '../constants/permissions';

const useIsTF911Enabled = () => {
  const user = useSelector(state => state.sinatra.user);

  const currentPSAP = useSelector(state => state.psaps.currentPSAP);

  const permissions =
    user.profile && selectUserPermissionsByApp(user, 'capstone');

  const isTF911Enabled = useMemo(() => {
    return !!(
      (
        currentPSAP?.activeCapabilities?.[TF911] &&
        permissions?.includes(TF911_PERMISSION)
      )
      // TODO: actual permission and update test
    );
  }, [currentPSAP, permissions]);

  return isTF911Enabled;
};

export default useIsTF911Enabled;
